export const Vision = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="#6EA644">
      <path d="M12 15c-1.654 0-3-1.346-3-3s1.346-3 3-3 3 1.346 3 3-1.346 3-3 3zm0-5c-1.103 0-2 .897-2 2s.897 2 2 2 2-.897 2-2-.897-2-2-2z" />
      <path d="M6 17c-1.103 0-2-.897-2-2v-5c0-1.103.897-2 2-2h2c.177-.01.372-.093.52-.226L9.792 6.5c.335-.302.751-.476 1.18-.5H13c.451.024.868.195 1.188.482l1.312 1.31c.133.118.328.198.528.208H18c1.103 0 2 .897 2 2v5c0 1.103-.897 2-2 2H6zm5-10c-.177.01-.372.093-.52.226L9.208 8.5c-.335.302-.751.476-1.18.5H6c-.551 0-1 .449-1 1v5c0 .552.449 1 1 1h12c.552 0 1-.448 1-1v-5c0-.551-.448-1-1-1h-2c-.451-.024-.868-.195-1.188-.482L13.5 7.208c-.131-.117-.324-.196-.521-.208H11z" />
      <circle cx="17" cy="11" r=".75" />
    </svg>
  )
}
